import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FaHome, FaCar, FaMapMarkedAlt, FaUsers, FaEnvelope,
  FaCalendarCheck, FaTimes, FaBars, FaPhoneAlt, FaShieldAlt
} from 'react-icons/fa';
import './navbar.css';

const navItems = [
  { to: '/', label: 'Home', icon: FaHome, end: true },
  { to: '/services', label: 'Services', icon: FaCar },
  { to: '/location', label: 'Destinations', icon: FaMapMarkedAlt },
  { to: '/booking', label: 'Booking', icon: FaCalendarCheck },
  { to: '/gallery', label: 'Gallery', icon: FaMapMarkedAlt },
  { to: '/aboutus', label: 'About Us', icon: FaUsers },
  { to: '/contactus', label: 'Contact', icon: FaEnvelope },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => (document.body.style.overflow = '');
  }, [isOpen]);

  const toggleMenu = () => setIsOpen(prev => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">

          {/* Logo */}
          <img
            src="/logo192.png"
            alt="Logo"
            className="logo"
            onClick={() => { closeMenu(); navigate('/'); }}
          />

          {/* Desktop Menu */}
          <ul className="desktop-menu">
            {navItems.map(item => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={closeMenu}
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Desktop Contact */}
          <div className="desktop-contact">
            <a href="tel:+94705549750" className="phone-link">
              <FaPhoneAlt /> +94 70 554 9750
            </a>

            <button
              className="book-btn"
              onClick={() => { closeMenu(); navigate('/booking'); }}
            >
              <FaCalendarCheck /> Book Now
            </button>
          </div>

          {/* Toggle */}
          <button className="menu-toggle" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>

        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isOpen ? 'active' : ''}`}>

        <div className="mobile-header">
          <img src="/logo192.png" className="mobile-logo" alt="Logo" />
          <button onClick={closeMenu}>
            <FaTimes />
          </button>
        </div>

        <ul className="mobile-nav-items">
          {navItems.map((item, idx) => (
            <li key={item.to} className="menu-item">
              <NavLink
                to={item.to}
                end={item.end}
                onClick={closeMenu}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                <item.icon />
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="mobile-contact">
          <a href="tel:+94705549750" className="mobile-phone">
            <FaPhoneAlt /> Call Us
          </a>

          <a
            href="https://wa.me/94705549750"
            className="mobile-whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaShieldAlt /> WhatsApp
          </a>
        </div>

        <div className="mobile-cta">
          <button onClick={() => { closeMenu(); navigate('/booking'); }}>
            <FaCalendarCheck /> Book Now
          </button>
        </div>

      </div>

      {/* Overlay */}
      <div
        className={`menu-overlay ${isOpen ? 'active' : ''}`}
        onClick={closeMenu}
      />
    </>
  );
};

export default Navbar;